<template>
  <l-table
    class="l-table-layout-wraper"
    :isShowNum="false"
    :highlightCurrentRow="false"
    :stripe="false"
    :isRowHover="false"
    :showOverflow="false"
    :isColumnResizable="false"
    :showHeader="false"
    isNotMinWidth
    borderType="none"
    height="notset"
    :columns="columns"
    :dataSource="rows"
    :cellStyle="cellStyle"
    :mergeCells="mergeCells"
    :minHeight="0"

    :style="{
      'border-top':border,
      'border-left':border
    }"
  >
    <template v-for="(col, index) in columns" v-slot:[col.prop]="scope">
      <div
        :class="['l-rblock','l-table-layout-wraper-td']"
        :style="{
          height: `${getCell(col.prop, scope.$rowIndex).height}px`,
          'border-right':border,
          'border-bottom':border
        }"
        :key="index"
      >
        <l-form-wraper :parentType="data.type" :myComponents="getCell(col.prop, scope.$rowIndex).children || []" />
      </div>
    </template>
  </l-table>
</template>

<script>
export default {
  name: "tableLayout-wraper",
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  computed: {
    columns() {
      return this.data.cols.map((t) => ({ isNotAutoWrap: false, ...t }));
    },
    rows() {
      const rows = [];
      let { cells } = this.data;
      for (let cell of cells) {
        let row = rows[cell.rowIndex];
        if (!row) {
          row = {};
          rows[cell.rowIndex] = row;
        }
        row[cell.colId] = "";
      }
      return rows;
    },
    cellStyle(){
      let res = {cursor: 'auto', height: '1px'};     
      return res;
    },
    mergeCells(){
      let { cells,cols } = this.data;
      let res = [];
      for (let cell of cells) {
        if(cell.rowspan > 1 || cell.colspan >1){
          let col = cols.findIndex(t=>t.prop == cell.colId);
          res.push({
            rowspan: cell.rowspan,
            colspan: cell.colspan,
            row: cell.rowIndex,
            col: col
          })
        }
      }
      return res
    },
    border(){
      return  `${this.data.borderWidth}px solid ${this.data.borderColor}`
    }
  },
  methods: {
    getCell(colId, rowIndex) {
      let { cells } = this.data;
      return cells.find((t) => t.colId == colId && t.rowIndex == rowIndex) || {};
    },
  },
};
</script>
